// extracted by mini-css-extract-plugin
export default {"slider":"slider-ui_slider__7g7ns","slider__slide":"slider-ui_slider__slide__yPhNo","slider__slide_activeSlide":"slider-ui_slider__slide_activeSlide__OW2SF"};